export const BuildInfo = {timestamp:1770425136000}
